import { TerminalController } from '../controller/TerminalController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { EndpointDetailsWebComponentSchema } from '../../../endpointDetails/types';

export class TerminalWebComponent extends BaseWebComponentElement {
  public controller: TerminalController;
  private _maxFilesSize: number = 0;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TerminalController,
    });
  }

  handleDisconnect() {
    this.controller.handleDisconnect();
  }

  set endpoint(value: EndpointDetailsWebComponentSchema | null) {
    this.setAttribute('data-endpoint', JSON.stringify(value));
    this.controller.handleDataLoaded();
  }

  set authenticationSettings(value: any) {
    this.setAttribute('data-authentication-settings', JSON.stringify(value));
  }

  get authenticationSettings() {
    const value = this.getAttribute('data-authentication-settings');
    return value ? JSON.parse(value) : null;
  }

  get endpoint(): EndpointDetailsWebComponentSchema | null {
    const value = this.getAttribute('data-endpoint');

    return value ? JSON.parse(value) : null;
  }

  set maxFilesSize(value: number) {
    this._maxFilesSize = value
  }

  get maxFilesSize(): number {
    return this._maxFilesSize;
  }

  sendMessage(message) {
    this.controller?.sendMessage(message);
  }
}
